import store from "@/store/BookingStore";
import { funnelSteps } from "./funnelSteps/steps";
import { NavigationGuardWithThis } from "vue-router"
import getCookie from "@/utils/getCookie";
import refresh from "@/logic/contact/refresh";
import RouteNameEnum from "./RouteNameEnum";
import RoutePathEnum from "./RoutePathEnum";
import { hanldeSecureless } from "./funnelSteps/middleware/hanldeSecureless";
import getQueryParams from "@/utils/getQueryParams";

const beforeEachRoute: NavigationGuardWithThis<undefined> = async (to, from, next) => {

    console.log("[Middleware] Navigating from", from.name, "to", to.name);
    document.querySelector("body")!.style.visibility = "visible";

    const queryParams = getQueryParams()
    if (queryParams.token) {
        store.commit('setToken', queryParams.token)
    }

    if (to.name === RouteNameEnum.UserInfoV2 && store.getters.getIsWidgetMode) {
        console.log("[Middleware] Widget mode: user-info step is skipped (login via first participant save).");
        return next({ path: RoutePathEnum.OptionsV2, query: getQueryParams() });
    }

    if (to.name === RouteNameEnum.WidgetCartSuccess) {
        if (!store.getters.getIsWidgetMode) {
            return next({ path: RoutePathEnum.OptionsV2, query: getQueryParams() });
        }
        const checkoutMode = store.getters.getWidgetCheckoutMode
        if (checkoutMode !== 'cart' && checkoutMode !== 'payment') {
            return next({ path: RoutePathEnum.OptionsV2, query: getQueryParams() });
        }
        return next();
    }

    // Find matching funnel step
    const step = funnelSteps.find((s) => s.name === to.name);
    if (!step) {
        console.log("[Middleware] No funnel step defined for route:", to.name);
        return next();
    }
    console.log("[Middleware] Found funnel step:", step.name);


    // Check if the URL contains a token that allows the user to act as if they are logged in (if so, it will set the loggedUser in the store)
    const loggedInSecurless = hanldeSecureless()

    // Restore session from cookies when Vuex was reset (e.g. new booking funnel on same domain)
    if (!store.state.loggedUser && !loggedInSecurless && getCookie("user-id-token")) {
        console.log("[Middleware] Restoring user session from cookies");
        await refresh();
    }

    // Handle routes that require authentication
    if (step.hasToBeLoggedIn) {
        console.log("[Middleware] Step requires logged in user");
        // Check if user is logged in
        if (!store.state.loggedUser) {
            console.log("[Middleware] No logged user found in store");
            // Check for cookie token
            if (!getCookie("user-id-token")) {
                if (!loggedInSecurless) {
                    if (store.getters.getIsWidgetMode) {
                        console.log("[Middleware] No token in widget mode. Redirecting to Options (login via first participant save).");
                        return next({ path: RoutePathEnum.OptionsV2, query: getQueryParams() });
                    }
                    console.log("[Middleware] No token found. Redirecting to UserInfoV2");
                    return next({ path: RoutePathEnum.UserInfoV2, query: getQueryParams() });
                }

            } else {
                console.log("[Middleware] Token found. Refreshing user session");
                await refresh();
            }
        } else {
            console.log("[Middleware] User is already logged in. Redirecting to page");
        }
    }

    // Run the funnel step logic
    console.log("[Middleware] Running funnel step logic for", step.name);
    const redirectTo: string | false = await step.run();

    if (redirectTo) {
        console.log("[Middleware] Funnel step returned redirect route:", redirectTo,
            +  getQueryParams()
        );
        return next({ path: redirectTo, query: getQueryParams() });
    } else {
        const queryParams = getQueryParams()

        console.log("[Middleware] Funnel step passed. Continuing navigation", queryParams);
        return next();
    }
};


export default beforeEachRoute